import React, { forwardRef } from 'react';

const EInvoicePrintTemplate = forwardRef(({ data, invoiceData }, ref) => {
    if (!data || !invoiceData) return null;

    const company = data?.Company || data?.companyId || data?.company || {};
    
    // E-Invoice details from data
    const irn = data?.irn || '';
    const ackNo = data?.ack_no || '';
    const ackDate = data?.ack_date || '';
    const einvoiceStatus = data?.einvoice_status || 'Generated';
    const cancelStatus = einvoiceStatus === 'CANCELLED' ? 'Y' : 'N';
    const signedQR = data?.signed_qr_code || '';

    return (
        <div 
            ref={ref} 
            className="einvoice-print-template" 
            style={{ 
                width: '210mm', 
                minHeight: '297mm', 
                padding: '10mm', 
                background: '#fff', 
                color: '#000', 
                fontFamily: 'Arial, sans-serif',
                fontSize: '10px',
                boxSizing: 'border-box',
                position: 'absolute',
                top: '-9999px',
                left: '-9999px',
                zIndex: -1
            }}
        >
            {/* Header */}
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '15px' }}>
                <div>
                    <h1 style={{ fontSize: '24px', fontWeight: 'bold', margin: '0 0 5px 0', color: '#1e3a8a' }}>Government of India e-Invoice System</h1>
                    <div style={{ fontSize: '12px', color: '#4b5563' }}>Tax Invoice / IRN Acknowledgement Copy</div>
                </div>
                {signedQR && (
                    <div>
                        <img 
                            src={signedQR.startsWith('data:image') ? signedQR : `https://api.qrserver.com/v1/create-qr-code/?size=500x500&data=${encodeURIComponent(signedQR)}`} 
                            alt="QR Code" 
                            style={{ width: '100px', height: '100px', border: '1px solid #000', padding: '2px' }} 
                            crossOrigin="anonymous" 
                        />
                    </div>
                )}
            </div>

            {/* Section 1: e-Invoice Details */}
            <div style={{ border: '1px solid #60a5fa', marginBottom: '10px' }}>
                <div style={{ background: '#eff6ff', padding: '4px 8px', fontWeight: 'bold', borderBottom: '1px solid #60a5fa', color: '#1e3a8a' }}>
                    1. e-Invoice Details
                </div>
                <div style={{ display: 'flex', borderBottom: '1px solid #e5e7eb' }}>
                    <div style={{ flex: '0 0 45%', padding: '4px 8px', borderRight: '1px solid #e5e7eb' }}>
                        <div style={{ fontWeight: 'bold' }}>IRN</div>
                        <div style={{ wordBreak: 'break-all', fontSize: '9px' }}>{irn}</div>
                    </div>
                    <div style={{ flex: '1', padding: '4px 8px', borderRight: '1px solid #e5e7eb' }}>
                        <div style={{ fontWeight: 'bold' }}>Ack. No.</div>
                        <div>{ackNo}</div>
                    </div>
                    <div style={{ flex: '1', padding: '4px 8px', borderRight: '1px solid #e5e7eb' }}>
                        <div style={{ fontWeight: 'bold' }}>Ack. Date</div>
                        <div>{ackDate}</div>
                    </div>
                    <div style={{ flex: '1', padding: '4px 8px', borderRight: '1px solid #e5e7eb' }}>
                        <div style={{ fontWeight: 'bold' }}>Status</div>
                        <div>{einvoiceStatus === 'CANCELLED' ? 'Cancelled' : 'Generated'}</div>
                    </div>
                    <div style={{ flex: '1', padding: '4px 8px', borderRight: '1px solid #e5e7eb' }}>
                        <div style={{ fontWeight: 'bold' }}>Cancel Status</div>
                        <div>{cancelStatus}</div>
                    </div>
                    <div style={{ flex: '1', padding: '4px 8px' }}>
                        <div style={{ fontWeight: 'bold' }}>Message</div>
                        <div style={{ fontSize: '9px' }}>{einvoiceStatus === 'CANCELLED' ? 'IRN Cancelled' : 'IRN generated successfully'}</div>
                    </div>
                </div>
            </div>

            {/* Section 2: Transaction Details */}
            <div style={{ border: '1px solid #60a5fa', marginBottom: '10px' }}>
                <div style={{ background: '#eff6ff', padding: '4px 8px', fontWeight: 'bold', borderBottom: '1px solid #60a5fa', color: '#1e3a8a' }}>
                    2. Transaction Details
                </div>
                <div style={{ display: 'flex' }}>
                    <div style={{ flex: '1', padding: '4px 8px', borderRight: '1px solid #e5e7eb' }}>
                        <div style={{ fontWeight: 'bold' }}>Category</div>
                        <div>B2B</div>
                    </div>
                    <div style={{ flex: '1', padding: '4px 8px', borderRight: '1px solid #e5e7eb' }}>
                        <div style={{ fontWeight: 'bold' }}>Document No</div>
                        <div>{invoiceData.invoiceNo}</div>
                    </div>
                    <div style={{ flex: '1', padding: '4px 8px', borderRight: '1px solid #e5e7eb' }}>
                        <div style={{ fontWeight: 'bold' }}>Document Type</div>
                        <div>Tax invoice</div>
                    </div>
                    <div style={{ flex: '1', padding: '4px 8px' }}>
                        <div style={{ fontWeight: 'bold' }}>Document Date</div>
                        <div>{invoiceData.invoiceDate}</div>
                    </div>
                </div>
            </div>

            {/* Section 3: Party Details */}
            <div style={{ border: '1px solid #60a5fa', marginBottom: '10px' }}>
                <div style={{ background: '#eff6ff', padding: '4px 8px', fontWeight: 'bold', borderBottom: '1px solid #60a5fa', color: '#1e3a8a' }}>
                    3. Party Details
                </div>
                <div style={{ display: 'flex', borderBottom: '1px solid #60a5fa' }}>
                    <div style={{ flex: '1', padding: '4px 8px', borderRight: '1px solid #60a5fa' }}>
                        <div style={{ fontWeight: 'bold', fontSize: '11px', marginBottom: '4px' }}>Seller</div>
                        <div style={{ marginBottom: '2px' }}><span style={{ color: '#4b5563' }}>Name : </span>{company?.company_name || company?.companyName || ''}</div>
                        <div style={{ marginBottom: '2px' }}><span style={{ color: '#4b5563' }}>GSTIN : </span>{company?.company_gst_number || company?.companyGstNumber || ''}</div>
                        <div style={{ marginBottom: '2px' }}><span style={{ color: '#4b5563' }}>Address : </span>{company?.company_address || company?.companyAddress || ''}</div>
                        <div style={{ marginBottom: '2px' }}><span style={{ color: '#4b5563' }}>State / Code : </span>{company?.company_state || company?.companyState || ''} / {company?.company_state_code || company?.companyStateCode || ''}</div>
                        <div><span style={{ color: '#4b5563' }}>PIN : </span>{company?.company_pin_code || company?.companyPinCode || ''}</div>
                    </div>
                    <div style={{ flex: '1', padding: '4px 8px' }}>
                        <div style={{ fontWeight: 'bold', fontSize: '11px', marginBottom: '4px' }}>Buyer</div>
                        <div style={{ marginBottom: '2px' }}><span style={{ color: '#4b5563' }}>Name : </span>{invoiceData.buyer.name}</div>
                        <div style={{ marginBottom: '2px' }}><span style={{ color: '#4b5563' }}>GSTIN : </span>{invoiceData.buyer.gstin}</div>
                        <div style={{ marginBottom: '2px' }}><span style={{ color: '#4b5563' }}>Address : </span>{invoiceData.buyer.address}{invoiceData.buyer.cityState ? `, ${invoiceData.buyer.cityState}` : ''}</div>
                        <div style={{ marginBottom: '2px' }}><span style={{ color: '#4b5563' }}>State / Code : </span>{invoiceData.buyer.placeOfSupply} / {invoiceData.buyer.stateCode}</div>
                        <div><span style={{ color: '#4b5563' }}>PIN : </span>{data?.customerPinCode || data?.customer_pin_code || ''}</div>
                    </div>
                </div>
                <div style={{ display: 'flex' }}>
                    <div style={{ flex: '1', padding: '4px 8px', borderRight: '1px solid #60a5fa' }}>
                        <div style={{ fontWeight: 'bold', fontSize: '11px', marginBottom: '4px' }}>Dispatcher</div>
                        <div style={{ marginBottom: '2px' }}><span style={{ color: '#4b5563' }}>Name : </span>{company?.company_name || company?.companyName || ''}</div>
                        <div style={{ marginBottom: '2px' }}><span style={{ color: '#4b5563' }}>Address : </span>{company?.company_address || company?.companyAddress || ''}</div>
                        <div><span style={{ color: '#4b5563' }}>State / Code : </span>{company?.company_state || company?.companyState || ''} / {company?.company_state_code || company?.companyStateCode || ''}</div>
                    </div>
                    <div style={{ flex: '1', padding: '4px 8px' }}>
                        <div style={{ fontWeight: 'bold', fontSize: '11px', marginBottom: '4px' }}>Shipping</div>
                        <div style={{ marginBottom: '2px' }}><span style={{ color: '#4b5563' }}>Name : </span>{invoiceData.consignee.name}</div>
                        <div style={{ marginBottom: '2px' }}><span style={{ color: '#4b5563' }}>Address : </span>{invoiceData.consignee.address}{invoiceData.consignee.cityState ? `, ${invoiceData.consignee.cityState}` : ''}</div>
                        <div><span style={{ color: '#4b5563' }}>State / Code : </span>{invoiceData.consignee.placeOfSupply} / {invoiceData.consignee.stateCode}</div>
                    </div>
                </div>
            </div>

            {/* Section 4: Goods Details */}
            <div style={{ border: '1px solid #60a5fa', marginBottom: '10px' }}>
                <div style={{ background: '#eff6ff', padding: '4px 8px', fontWeight: 'bold', borderBottom: '1px solid #60a5fa', color: '#1e3a8a' }}>
                    4. Goods Details
                </div>
                <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'center', fontSize: '9px' }}>
                    <thead>
                        <tr>
                            <th style={{ borderBottom: '1px solid #60a5fa', borderRight: '1px solid #e5e7eb', padding: '4px' }}>S.<br/>No.</th>
                            <th style={{ borderBottom: '1px solid #60a5fa', borderRight: '1px solid #e5e7eb', padding: '4px', textAlign: 'left' }}>Product Description</th>
                            <th style={{ borderBottom: '1px solid #60a5fa', borderRight: '1px solid #e5e7eb', padding: '4px' }}>HSN<br/>Code</th>
                            <th style={{ borderBottom: '1px solid #60a5fa', borderRight: '1px solid #e5e7eb', padding: '4px' }}>Quantity</th>
                            <th style={{ borderBottom: '1px solid #60a5fa', borderRight: '1px solid #e5e7eb', padding: '4px' }}>Unit</th>
                            <th style={{ borderBottom: '1px solid #60a5fa', borderRight: '1px solid #e5e7eb', padding: '4px' }}>Unit Price</th>
                            <th style={{ borderBottom: '1px solid #60a5fa', borderRight: '1px solid #e5e7eb', padding: '4px' }}>Discount</th>
                            <th style={{ borderBottom: '1px solid #60a5fa', borderRight: '1px solid #e5e7eb', padding: '4px' }}>Taxable<br/>Value</th>
                            <th style={{ borderBottom: '1px solid #60a5fa', borderRight: '1px solid #e5e7eb', padding: '4px' }}>Tax Rate</th>
                            <th style={{ borderBottom: '1px solid #60a5fa', borderRight: '1px solid #e5e7eb', padding: '4px' }}>Other</th>
                            <th style={{ borderBottom: '1px solid #60a5fa', padding: '4px' }}>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        {invoiceData.items.map((item, idx) => {
                            // Deduce numerical values for calculation
                            const qty = parseFloat(item.qty.replace(/,/g, '')) || 0;
                            const rate = parseFloat(item.rate.replace(/,/g, '')) || 0;
                            const amount = parseFloat(item.amount.replace(/,/g, '')) || 0;
                            const taxRate = (invoiceData.totals.isLocal ? (invoiceData.totals.tax1Rate + invoiceData.totals.tax2Rate) : invoiceData.totals.tax1Rate) || 18;
                            
                            // Pro-rata discount
                            const discountRatio = parseFloat(invoiceData.totals.discount) / parseFloat(invoiceData.totals.subTotal.replace(/,/g, '')) || 0;
                            const itemDiscount = amount * discountRatio;
                            const itemTaxable = amount - itemDiscount;
                            const itemTax = (itemTaxable * taxRate) / 100;
                            const itemTotal = itemTaxable + itemTax;

                            return (
                                <tr key={idx}>
                                    <td style={{ borderBottom: '1px solid #e5e7eb', borderRight: '1px solid #e5e7eb', padding: '4px' }}>{item.srNo}</td>
                                    <td style={{ borderBottom: '1px solid #e5e7eb', borderRight: '1px solid #e5e7eb', padding: '4px', textAlign: 'left', textTransform: 'uppercase' }}>
                                        {item.product} {item.model ? `- ${item.model}` : ''}
                                    </td>
                                    <td style={{ borderBottom: '1px solid #e5e7eb', borderRight: '1px solid #e5e7eb', padding: '4px' }}>{item.hsn}</td>
                                    <td style={{ borderBottom: '1px solid #e5e7eb', borderRight: '1px solid #e5e7eb', padding: '4px' }}>{qty}</td>
                                    <td style={{ borderBottom: '1px solid #e5e7eb', borderRight: '1px solid #e5e7eb', padding: '4px' }}>{item.unit || 'NOS'}</td>
                                    <td style={{ borderBottom: '1px solid #e5e7eb', borderRight: '1px solid #e5e7eb', padding: '4px', textAlign: 'right' }}>{rate.toFixed(2)}</td>
                                    <td style={{ borderBottom: '1px solid #e5e7eb', borderRight: '1px solid #e5e7eb', padding: '4px', textAlign: 'right' }}>{itemDiscount.toFixed(2)}</td>
                                    <td style={{ borderBottom: '1px solid #e5e7eb', borderRight: '1px solid #e5e7eb', padding: '4px', textAlign: 'right' }}>{itemTaxable.toFixed(2)}</td>
                                    <td style={{ borderBottom: '1px solid #e5e7eb', borderRight: '1px solid #e5e7eb', padding: '4px' }}>{taxRate.toFixed(2)}</td>
                                    <td style={{ borderBottom: '1px solid #e5e7eb', borderRight: '1px solid #e5e7eb', padding: '4px', textAlign: 'right' }}>0.00</td>
                                    <td style={{ borderBottom: '1px solid #e5e7eb', padding: '4px', textAlign: 'right' }}>{itemTotal.toFixed(2)}</td>
                                </tr>
                            );
                        })}
                        
                        {parseFloat(invoiceData.totals.extra) > 0 && (() => {
                            const extraAmt = parseFloat(invoiceData.totals.extra);
                            const taxRate = (invoiceData.totals.isLocal ? (invoiceData.totals.tax1Rate + invoiceData.totals.tax2Rate) : invoiceData.totals.tax1Rate) || 18;
                            const itemTax = (extraAmt * taxRate) / 100;
                            const itemTotal = extraAmt + itemTax;
                            const extraName = invoiceData.extra_charges_name || data?.extra_charges_name || 'Extra Charges';
                            return (
                                <tr>
                                    <td style={{ borderBottom: '1px solid #e5e7eb', borderRight: '1px solid #e5e7eb', padding: '4px' }}>{invoiceData.items.length + 1}</td>
                                    <td style={{ borderBottom: '1px solid #e5e7eb', borderRight: '1px solid #e5e7eb', padding: '4px', textAlign: 'left', textTransform: 'uppercase' }}>
                                        {extraName}
                                    </td>
                                    <td style={{ borderBottom: '1px solid #e5e7eb', borderRight: '1px solid #e5e7eb', padding: '4px' }}>999732</td>
                                    <td style={{ borderBottom: '1px solid #e5e7eb', borderRight: '1px solid #e5e7eb', padding: '4px' }}>1</td>
                                    <td style={{ borderBottom: '1px solid #e5e7eb', borderRight: '1px solid #e5e7eb', padding: '4px' }}>OTH</td>
                                    <td style={{ borderBottom: '1px solid #e5e7eb', borderRight: '1px solid #e5e7eb', padding: '4px', textAlign: 'right' }}>{extraAmt.toFixed(2)}</td>
                                    <td style={{ borderBottom: '1px solid #e5e7eb', borderRight: '1px solid #e5e7eb', padding: '4px', textAlign: 'right' }}>0.00</td>
                                    <td style={{ borderBottom: '1px solid #e5e7eb', borderRight: '1px solid #e5e7eb', padding: '4px', textAlign: 'right' }}>{extraAmt.toFixed(2)}</td>
                                    <td style={{ borderBottom: '1px solid #e5e7eb', borderRight: '1px solid #e5e7eb', padding: '4px' }}>{taxRate.toFixed(2)}</td>
                                    <td style={{ borderBottom: '1px solid #e5e7eb', borderRight: '1px solid #e5e7eb', padding: '4px', textAlign: 'right' }}>0.00</td>
                                    <td style={{ borderBottom: '1px solid #e5e7eb', padding: '4px', textAlign: 'right' }}>{itemTotal.toFixed(2)}</td>
                                </tr>
                            );
                        })()}

                        {parseFloat(invoiceData.totals.insurance) > 0 && (() => {
                            const insuranceAmt = parseFloat(invoiceData.totals.insurance);
                            const taxRate = (invoiceData.totals.isLocal ? (invoiceData.totals.tax1Rate + invoiceData.totals.tax2Rate) : invoiceData.totals.tax1Rate) || 18;
                            const itemTax = (insuranceAmt * taxRate) / 100;
                            const itemTotal = insuranceAmt + itemTax;
                            const baseIdx = invoiceData.items.length + (parseFloat(invoiceData.totals.extra) > 0 ? 2 : 1);
                            return (
                                <tr>
                                    <td style={{ borderBottom: '1px solid #e5e7eb', borderRight: '1px solid #e5e7eb', padding: '4px' }}>{baseIdx}</td>
                                    <td style={{ borderBottom: '1px solid #e5e7eb', borderRight: '1px solid #e5e7eb', padding: '4px', textAlign: 'left', textTransform: 'uppercase' }}>
                                        INSURANCE CHARGES
                                    </td>
                                    <td style={{ borderBottom: '1px solid #e5e7eb', borderRight: '1px solid #e5e7eb', padding: '4px' }}>997136</td>
                                    <td style={{ borderBottom: '1px solid #e5e7eb', borderRight: '1px solid #e5e7eb', padding: '4px' }}>1</td>
                                    <td style={{ borderBottom: '1px solid #e5e7eb', borderRight: '1px solid #e5e7eb', padding: '4px' }}>OTH</td>
                                    <td style={{ borderBottom: '1px solid #e5e7eb', borderRight: '1px solid #e5e7eb', padding: '4px', textAlign: 'right' }}>{insuranceAmt.toFixed(2)}</td>
                                    <td style={{ borderBottom: '1px solid #e5e7eb', borderRight: '1px solid #e5e7eb', padding: '4px', textAlign: 'right' }}>0.00</td>
                                    <td style={{ borderBottom: '1px solid #e5e7eb', borderRight: '1px solid #e5e7eb', padding: '4px', textAlign: 'right' }}>{insuranceAmt.toFixed(2)}</td>
                                    <td style={{ borderBottom: '1px solid #e5e7eb', borderRight: '1px solid #e5e7eb', padding: '4px' }}>{taxRate.toFixed(2)}</td>
                                    <td style={{ borderBottom: '1px solid #e5e7eb', borderRight: '1px solid #e5e7eb', padding: '4px', textAlign: 'right' }}>0.00</td>
                                    <td style={{ borderBottom: '1px solid #e5e7eb', padding: '4px', textAlign: 'right' }}>{itemTotal.toFixed(2)}</td>
                                </tr>
                            );
                        })()}

                    </tbody>
                    <tfoot>
                        <tr style={{ background: '#eff6ff', fontWeight: 'bold' }}>
                            <td colSpan="11" style={{ padding: 0 }}>
                                <div style={{ display: 'flex', borderTop: '1px solid #60a5fa' }}>
                                    <div style={{ padding: '4px', borderRight: '1px solid #e5e7eb', flex: '1', textAlign: 'right' }}>Taxable Amt</div>
                                    <div style={{ padding: '4px', borderRight: '1px solid #e5e7eb', flex: '1', textAlign: 'left' }}>{invoiceData.totals.taxableAmount.replace(/,/g, '')}</div>
                                    
                                    <div style={{ padding: '4px', borderRight: '1px solid #e5e7eb', flex: '1', textAlign: 'right' }}>CGST Amt</div>
                                    <div style={{ padding: '4px', borderRight: '1px solid #e5e7eb', flex: '1', textAlign: 'left' }}>{invoiceData.totals.isLocal ? invoiceData.totals.tax1.replace(/,/g, '') : '0.00'}</div>
                                    
                                    <div style={{ padding: '4px', borderRight: '1px solid #e5e7eb', flex: '1', textAlign: 'right' }}>SGST Amt</div>
                                    <div style={{ padding: '4px', borderRight: '1px solid #e5e7eb', flex: '1', textAlign: 'left' }}>{invoiceData.totals.isLocal ? invoiceData.totals.tax2.replace(/,/g, '') : '0.00'}</div>
                                    
                                    <div style={{ padding: '4px', borderRight: '1px solid #e5e7eb', flex: '1', textAlign: 'right' }}>IGST Amt</div>
                                    <div style={{ padding: '4px', borderRight: '1px solid #e5e7eb', flex: '1', textAlign: 'left' }}>{!invoiceData.totals.isLocal ? invoiceData.totals.tax1.replace(/,/g, '') : '0.00'}</div>
                                    
                                    <div style={{ padding: '4px', borderRight: '1px solid #e5e7eb', flex: '1', textAlign: 'right' }}>CESS Amt</div>
                                    <div style={{ padding: '4px', borderRight: '1px solid #e5e7eb', flex: '1', textAlign: 'left' }}>0.00</div>
                                    
                                    <div style={{ padding: '4px', borderRight: '1px solid #e5e7eb', flex: '1', textAlign: 'right', color: '#1e3a8a' }}>Total Inv. Amt</div>
                                    <div style={{ padding: '4px', flex: '1', textAlign: 'right', color: '#1e3a8a' }}>{invoiceData.totals.grandTotal.replace(/,/g, '')}</div>
                                </div>
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>

            {/* Section 5: E-Way Bill / Additional Details */}
            <div style={{ border: '1px solid #60a5fa' }}>
                <div style={{ background: '#eff6ff', padding: '4px 8px', fontWeight: 'bold', borderBottom: '1px solid #60a5fa', color: '#1e3a8a' }}>
                    5. E-Way Bill / Additional Details
                </div>
                <div style={{ display: 'flex', borderBottom: '1px solid #e5e7eb' }}>
                    <div style={{ flex: '1', padding: '4px 8px', borderRight: '1px solid #e5e7eb' }}>
                        <div style={{ fontWeight: 'bold' }}>Eway Bill No</div>
                        <div>{invoiceData.eWayBillNo || ''}</div>
                    </div>
                    <div style={{ flex: '1', padding: '4px 8px', borderRight: '1px solid #e5e7eb' }}>
                        <div style={{ fontWeight: 'bold' }}>Eway Bill Date</div>
                        <div>{data?.eway_bill_date || data?.ewb_date || ''}</div>
                    </div>
                    <div style={{ flex: '1', padding: '4px 8px', borderRight: '1px solid #e5e7eb' }}>
                        <div style={{ fontWeight: 'bold' }}>Valid Till Date</div>
                        <div>{data?.ewb_valid_upto || ''}</div>
                    </div>
                    <div style={{ flex: '1', padding: '4px 8px' }}>
                        <div style={{ fontWeight: 'bold' }}>Vehicle No</div>
                        <div>{invoiceData.vehicleNo || ''}</div>
                    </div>
                </div>
                <div style={{ display: 'flex' }}>
                    <div style={{ flex: '1', padding: '4px 8px', borderRight: '1px solid #e5e7eb' }}>
                        <div style={{ fontWeight: 'bold' }}>Transporter</div>
                        <div>{invoiceData.transporter || ''}</div>
                    </div>
                    <div style={{ flex: '1', padding: '4px 8px', borderRight: '1px solid #e5e7eb' }}>
                        <div style={{ fontWeight: 'bold' }}>Distance (KM)</div>
                        <div>{data?.ewb_distance || ''}</div>
                    </div>
                    <div style={{ flex: '1', padding: '4px 8px', borderRight: '1px solid #e5e7eb' }}>
                        <div style={{ fontWeight: 'bold' }}>Generated By</div>
                        <div>NIC-IRP</div>
                    </div>
                    <div style={{ flex: '1', padding: '4px 8px', textAlign: 'right' }}>
                        <div style={{ fontWeight: 'bold' }}>E-sign</div>
                        <div style={{ fontSize: '9px' }}>Digitally Signed by NIC-IRP</div>
                    </div>
                </div>
            </div>
            
        </div>
    );
});

export default EInvoicePrintTemplate;
